/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import ModalFull from '@components/modal/ModalFull';
import Colors from '@global/colors';

const BarcodeScanner = ({ show = false, onClose = () => {} }) => {
  if (!show) {
    return null;
  }

  return (
    <ModalFull
      show={show}
      onClose={onClose}
      title="Scan Barcode"
      noPortalSticky={true}>
      <View style={styles.permissionContainer}>
        <Image
          style={styles.permissionIcon}
          width={80}
          height={80}
          source={require('@assets/img/icons/no-product.svg')}
          svg
        />
        <SociollaText type="medium" style={styles.permissionTitle}>
          Barcode Scanner Not Available
        </SociollaText>
        <SociollaText style={styles.permissionText}>
          Barcode scanning is only available on mobile devices (iOS and
          Android).
        </SociollaText>
        <TouchableOpacity
          style={styles.permissionButton}
          activeOpacity={0.6}
          onPress={onClose}>
          <SociollaText type="medium" style={styles.permissionButtonText}>
            Close
          </SociollaText>
        </TouchableOpacity>
      </View>
    </ModalFull>
  );
};

const styles = StyleSheet.create({
  permissionContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 30,
  },
  permissionIcon: {
    marginBottom: 20,
  },
  permissionTitle: {
    fontSize: 20,
    color: Colors.black,
    marginBottom: 16,
    textAlign: 'center',
  },
  permissionText: {
    fontSize: 16,
    color: Colors.gray,
    textAlign: 'center',
    marginBottom: 30,
    lineHeight: 24,
  },
  permissionButton: {
    backgroundColor: Colors.primary,
    paddingHorizontal: 30,
    paddingVertical: 12,
    borderRadius: 8,
    minWidth: 120,
  },
  permissionButtonText: {
    color: Colors.white,
    fontSize: 16,
    textAlign: 'center',
  },
});

export default React.memo(BarcodeScanner);
